/**
 * MarketingShell — Shared Apple-fluid/glass page shell for /marketing/*.
 *
 * Mirrors the CRM design system (App.css: .glass, .ai-banner, --navy gradient,
 * Plus Jakarta heads, tabular numerics, soft --shadow-card cards).
 *
 *   <MarketingShell title="…" subtitle="…" actions={…}>
 *     {pageBody}
 *   </MarketingShell>
 *
 * Renders:
 *   • Sticky glass top-bar (back-drop blur + 0.5px border) with title/subtitle
 *     left + action buttons right
 *   • Dotted grain background layer (.bg-grain) for fluid depth
 *   • 1400px max-width content container w/ consistent 24px gutters
 */
import { Sparkles } from "lucide-react";

export default function MarketingShell({ title, subtitle, actions, children }) {
  return (
    <div className="mkt-shell bg-grain" data-testid="marketing-shell">
      <div className="mkt-topbar glass">
        <div className="mkt-topbar-inner">
          <div>
            <h1 className="mkt-title">{title}</h1>
            {subtitle && <p className="mkt-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="mkt-actions">{actions}</div>}
        </div>
      </div>
      <div className="mkt-body">{children}</div>
    </div>
  );
}

/** MarketingAIBanner — navy-gradient AI insight pane (matches CRM .ai-banner). */
export function MarketingAIBanner({ children, loading = false, label = "Claude AI", testid = "ai-marketing-banner" }) {
  return (
    <div className="ai-banner mkt-ai-banner" data-testid={testid}>
      <div className="ai-pill">
        <Sparkles style={{ width: 11, height: 11 }} />
        {label}
      </div>
      <p style={{ opacity: loading ? 0.55 : 1 }}>{children}</p>
    </div>
  );
}
